import React  from 'react';

import UserIcon from 'i5-user';
import Classes from "classnames";

export default function renderUrlGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-user-group-list-header');

    const user = gd.session.users.get(data.value);

    return (
        <div className={classes}>
            {!!user && <UserIcon className="group-user-header-icon" size="26" userId={data.value} hint={false}/>}
            <div className={Classes("group-user-header-value", {'no-user':!user})}>{user ? user.name : 'No user'}</div>
        </div>
    );
}